// A (possibly faster) way to get the current timestamp as an integer.
export default Date.now || function() {
  return new Date().getTime();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/backbone/node_modules/underscore/modules/now.js
// module id = 78
// module chunks = 0